/** Releases from our master/develop semantic-release channels (stable or rc.N). */
const VERSION =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-rc\.(0|[1-9]\d*))?$/;

export interface ClientRelease {
  version: string;
  buildId: string;
  refreshBeforeVersion: string | null;
}

export function parseClientVersion(value: unknown): number[] | null {
  if (typeof value !== "string" || value.length > 80) return null;
  const match = VERSION.exec(value);
  if (!match) return null;
  const parts = match.slice(1, 4).map(Number);
  if (match[4] !== undefined) parts.push(Number(match[4]));
  return parts.every((part) => Number.isSafeInteger(part)) ? parts : null;
}

export function compareClientVersions(a: string, b: string): number {
  const left = parseClientVersion(a);
  const right = parseClientVersion(b);
  if (!left || !right) throw new Error("Invalid client release version");
  for (let i = 0; i < 4; i++) {
    const l = left[i] ?? Infinity; // stable follows every rc of the same version
    const r = right[i] ?? Infinity;
    if (l !== r) return l < r ? -1 : 1;
  }
  return 0;
}

export function isClientRelease(value: unknown): value is ClientRelease {
  if (!value || typeof value !== "object") return false;
  const release = value as ClientRelease;
  return (
    !!parseClientVersion(release.version) &&
    typeof release.buildId === "string" &&
    /^[a-f0-9]{40}$/.test(release.buildId) &&
    (release.refreshBeforeVersion === null ||
      (!!parseClientVersion(release.refreshBeforeVersion) &&
        compareClientVersions(release.refreshBeforeVersion, release.version) <=
          0))
  );
}
